import React from 'react';
// import proptypes from 'prop-types';

export default function Alert(props) {
  const capital=(word)=>{
    return word.charAt(0).toUpperCase() + word.slice(1);
  }
  return (
    <div style={{height:'50px'}}>
    {props.alert && <div className="alert alert-warning alert-dismissible fade show" role="alert">
        <strong>{capital(props.alert.type)}</strong>: {props.alert.message}
    </div>}
    </div>
  )
}